import { apiFetch } from '../apiFetch'
export const getTags = async (query) => {
  return await apiFetch({
    path: `/tags?q=${query}`
  })
}
export const getTag = async (slug) => {
  return await apiFetch({
    path: `/admin/tags/${slug}`
  })
}

export const postTag = async (tag) => {
  return await apiFetch({
    method: 'POST',
    path: '/tags',
    payload: tag
  })
}

export const postTagItem = async (tagItem) => {
  return await apiFetch({
    method: 'POST',
    path: '/assign/tag',
    payload: tagItem
  })
}

export const deleteTagItem = async (tagItem) => {
  return await apiFetch({
    method: 'DELETE',
    path: '/remove/tag',
    payload: tagItem
  })
}
